import {WriteButton} from '../../../common/buttons/WriteActions';
import {Alert, Box, Button, Skeleton, Stack} from '@mui/material';
import {ArrowBackIosNew} from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {fillingAPI} from '../../../../services/FillingServices';
import {recipeAPI} from '../../../../services/RecipeServices';
import {itemAPI} from '../../../../services/ItemServices';
import {EditFilling} from './EditFilling';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {SaveFillingGuidRequest} from '../../../../models/Recipe/Filling/IFillingGuid';
import {getApiErrorMessage} from '../../../../common/apiErrors';
import {useState} from 'react';
import {DeleteFillingDialog} from '../DeleteFillingDialog';

export const EditFillingHOC = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const {t} = useAppTranslation();
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [deleteError, setDeleteError] = useState('');
    const {
        data: fillingData,
        error: fillingError,
        isLoading: fillingLoading,
        isSuccess: fillingSuccess
    } = fillingAPI.useGetFillingV2Query(id ?? '', {skip: !id});
    const {
        data: items,
        error: itemsError,
        isLoading: itemsLoading,
        isSuccess: itemsSuccess
    } = itemAPI.useGetAllItemsV2Query();
    const {
        data: recipes,
        error: recipesError,
        isLoading: recipesLoading,
        isSuccess: recipesSuccess
    } = recipeAPI.useGetRecipesV2AllLightQuery();
    const [updateFilling] = fillingAPI.useUpdateFillingV2Mutation();
    const [deleteFilling] = fillingAPI.useDeleteFillingV2Mutation();
    const ready = fillingSuccess && !!fillingData && itemsSuccess && recipesSuccess;
    const loading = fillingLoading || itemsLoading || recipesLoading;
    const handleSubmit = async (value: SaveFillingGuidRequest) => {
        if (!fillingData) return;
        const editedId = fillingData.id;
        const returnPage = (location.state as { returnPage?: number } | null)?.returnPage;
        await updateFilling({id: editedId, body: value}).unwrap();
        navigate('/app/recipes/fillings', {state: {expandedId: editedId, page: returnPage}});
    };
    const handleDelete = async () => {
        if (!fillingData) return false;
        setDeleteError('');
        try {
            await deleteFilling(fillingData.id).unwrap();
            navigate('/app/recipes/fillings');
            return true;
        } catch (error) {
            setDeleteError(getApiErrorMessage(error, t));
            return false;
        }
    };
    return <Box sx={{width: '100%'}}>
        <Button variant="outlined" startIcon={<ArrowBackIosNew/>}
                onClick={() => navigate('/app/recipes/fillings')}>{t('recipes:back_to_fillings')}</Button>
        {loading &&
            <Stack spacing={2} sx={{mt: 2}}><Skeleton variant="rounded" height={120}/><Skeleton variant="rounded"
                                                                                                height={220}/><Skeleton
                variant="rounded" height={180}/></Stack>}
        {(fillingError || itemsError || recipesError) && <Alert severity="error"
                                                                sx={{mt: 2}}>{getApiErrorMessage(fillingError || itemsError || recipesError, t)}</Alert>}
        {ready && <><EditFilling recipes={recipes} items={items} fillingData={fillingData} onSubmit={handleSubmit}/><WriteButton sx={{mt: 2}} color="error" variant="outlined" startIcon={<DeleteIcon/>} onClick={() => setDeleteOpen(true)}>{t('recipes:delete_filling')}</WriteButton>
            <DeleteFillingDialog open={deleteOpen} onClose={() => setDeleteOpen(false)} fillingName={fillingData.fillingName ?? ''} onDelete={handleDelete} error={deleteError}/></>}
    </Box>;
};
